var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"underline truncate text-gray-700",attrs:{"href":_vm.addressLink}},[_vm._v(_vm._s(_vm.addressDisplay))])}
var staticRenderFns = []

export { render, staticRenderFns }